module.exports = __webpack_public_path__ + "img/Sharp Edge.decab35e.png";